import { useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { AppContext } from '../../contexts/AppContext';
import { WIDTH_CLOSE_SIDEBAR, WIDTH_OPEN_SIDEBAR } from '../constants';

export default function useLayoutStyles() {

    const { state: { menu } } = React.useContext(AppContext);

    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.between(0, 1200));

    const { spacing, breakpoints } = useTheme()
    const small = useMediaQuery(breakpoints.down('sm'));
    const medium = useMediaQuery(breakpoints.down('md'));
    const large = useMediaQuery(breakpoints.down('lg'));
    

    const mobileTablet = small || medium

    const sideBarWidth = menu?.visibleMenu ? WIDTH_OPEN_SIDEBAR : WIDTH_CLOSE_SIDEBAR

    // console.log("sideBarWidth: ", sideBarWidth);
    
    
    

  // A sidebar SÓ existe quando `!smallScreen` (o template não a renderiza
  // abaixo de 1200 — ver common/template/index.tsx). Todo deslocamento que
  // compensa a largura dela precisa zerar na MESMA condição; caso contrário o
  // conteúdo fica empurrado por uma barra que não está na tela.
  const semSideBar = mobileTablet || smallScreen

  return {
    menuSideBarWidth: !smallScreen ? sideBarWidth : '100%',
    contentContainerMarginLeft: semSideBar ? 0 : sideBarWidth,
    positionSideBarClosedTooltip: -WIDTH_OPEN_SIDEBAR,
    smallScreen
  }

}
